import React, { useState, Fragment, useEffect } from 'react';
import styles from './ConTrend.module.css';
import { Card, Col, Input, Row, Select, Spin, Table, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { fetchJsData } from '../../../../api';
import { crawl, conActReducer } from '../../../../api/util';
import { fetchUserSearch, newApps, modApps, remApps, cardCss, tabPageCss } from './columns';
const { Text } = Typography;

const ConTrend = (props) => {
    const [load, setLoad] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (props.loader === false) {
            fetchData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.loader]);

    const fetchData = async () => {
        setLoad(true);
        const data = await fetchJsData({
            type: 'fetch',
            qry: 'fetConRelActsMods',
            firstVal: 'snapshot_v' + props.rele + '_0_0',
            secondVal: 'snapshot_v' + props.rele + '_0_0',
            thirdVal: 'snapshot_v' + props.rele + '_0_0',
            fourthVal: ['R-' + props.rele, 'R-' + (props.rele - 1), 'R-' + (props.rele - 2)],
        });
        setData(conActReducer(data['data']));
        setLoad(false);
    };

    return (
        <div>
            {/* Card */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                {/* <Col className="gutter-row" span={1}></Col> */}
                <Col className="gutter-row" span={23}>
                    <DisplayHeader
                        loader={props.loader}
                        submit={props.submit}
                        loadP={load}
                        setSubmit={props.setSubmit}
                        rel={props.rel}
                        usrRel={props.usrRel}
                        data={data}
                    />
                </Col>
            </Row>
        </div>
    );
};

const DisplayHeader = (props) => {
    const [load, setLoad] = useState(true);
    const [renderer, updateRender] = useState('tab1');

    const onTabChng = (key) => {
        updateRender(key);
        props.setSubmit(!props.submit);
    };

    const contentList = {
        tab1: (
            <FetchTabSearch
                submit={props.submit}
                rel={props.rel}
                usrRel={props.usrRel}
                data={props.data.filter((x) => x.release_name === 'R-' + props.rel && x.action.toUpperCase() === 'ADDED')}
                col={newApps}
                usrSel="ADDED"
            />
        ),
        tab2: (
            <FetchTabSearch
                submit={props.submit}
                rel={props.rel}
                usrRel={props.usrRel}
                data={props.data.filter((x) => x.release_name === 'R-' + props.rel && x.action.toUpperCase() === 'MODIFIED')}
                col={modApps}
                usrSel="MODIFIED"
            />
        ),
        tab3: (
            <FetchTabSearch
                submit={props.submit}
                rel={props.rel}
                usrRel={props.usrRel}
                data={props.data.filter((x) => x.release_name === 'R-' + props.rel && x.action.toUpperCase() === 'REMOVED')}
                col={remApps}
                usrSel="REMOVED"
            />
        ),
    };

    return (
        <Card
            style={{ width: '100%', minHeight: '80vh' }}
            // bodyStyle={{ padding: "0", borderStyle: "hidden" }}
            bodyStyle={cardCss}
            tabList={tabList}
            onTabChange={onTabChng}
            loading={props.loader}
        >
            {!props.loadP ? (
                contentList[renderer]
            ) : (
                <div className={styles.spinner}>
                    <Spin size="small" />
                </div>
            )}
        </Card>
    );
};

const FetchTabSearch = (props) => {
    const [searchVal, setSearchVal] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [origData, setOrigData] = useState([]);
    const [searchIndex, setSearchIndex] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // console.log('usr -', props.usrRel, props.rel);
        setLoading(true);
        const fetchData = async () => {
            const { data: users } = await fetchUserSearch(props.rel, props.rel - 1, props.usrSel, props.data);
            let id = 0;
            users.map((elem) => {
                elem.app_id = id++;
            });
            setOrigData(users);
            setFilteredData(users);
            const searchInd = users.map((user) => {
                const allValues = crawl(user);
                return { allValues: allValues.toString() };
            });
            setSearchIndex(searchInd);
            if (users) setLoading(false);
        };
        fetchData();
    }, [props.submit]);

    useEffect(() => {
        if (searchVal) {
            const reqData = searchIndex.map((user, index) => {
                if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0) return origData[index];
                return null;
            });
            setFilteredData(
                reqData.filter((user) => {
                    if (user) return true;
                    return false;
                })
            );
        } else setFilteredData(origData);
    }, [searchVal, origData, searchIndex, props.submit]);

    return (
        <>
            <div>
                <Row gutter={16}>
                    <Col span={24}>
                        <Card
                            title={
                                loading ? (
                                    <div>
                                        <Spin size="small" />
                                    </div>
                                ) : (
                                    <Row>
                                        <Col spane={6}>
                                            <Text>
                                                {'Release - ' + (props.usrRel ? props.usrRel.split('snapshot_v')[1].split('_')[0] : '')}
                                            </Text>
                                        </Col>
                                    </Row>
                                )
                            }
                            size="small"
                            headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                            // style={{ maxHeight: "78vh", overflow: "scroll" }}
                            extra={
                                <Row>
                                    <Col span={21}>
                                        <Input
                                            onChange={(e) => setSearchVal(e.target.value)}
                                            prefix={<SearchOutlined className="site-form-item-icon" />}
                                            placeholder="Crawl Search"
                                            allowClear
                                        />
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col className="gutter-row" span={2}>
                                        {' '}
                                    </Col>
                                </Row>
                            }
                        >
                            <Fragment>
                                <Table
                                    rowKey="app_id"
                                    size="small"
                                    bordered
                                    scroll={{ x: 550, y: 900 }}
                                    style={{ margin: '2px' }}
                                    dataSource={filteredData}
                                    columns={props.col(filteredData.length)}
                                    loading={loading}
                                    pagination={{
                                        pageSizeOptions: ['10', '30', '60', '100', '1000'],
                                        defaultPageSize: ['50'],
                                        showSizeChanger: true,
                                        // style: { padding: "0", marginBottom: "0" },
                                        style: tabPageCss,
                                    }}
                                />
                            </Fragment>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

const tabList = [
    {
        key: 'tab1',
        tab: 'New Connectors',
    },
    {
        key: 'tab2',
        tab: 'Modified Connectors',
    },
    {
        key: 'tab3',
        tab: 'Removed Connectors',
    },
];

export default ConTrend;
